import { enableProdMode, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { IonicStorageModule } from '@ionic/storage-angular';
// import { IonicModule } from '@ionic/angular';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';

// import {  HttpClientModule } from '@angular/common/http';

// import { ServiceWorkerModule, provideServiceWorker } from '@angular/service-worker';


defineCustomElements(window);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes),
    // importProvidersFrom(IonicModule.forRoot({})),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(IonicStorageModule.forRoot()),
    // importProvidersFrom(
    //   ServiceWorkerModule.register('ngsw-worker.js', {
    //     enabled: environment.production,
    //     // Register the ServiceWorker as soon as the application is stable
    //     // or after 30 seconds (whichever comes first).
    //     registrationStrategy: 'registerWhenStable:30000',
    //   })
    // ),
    // provideServiceWorker('ngsw-worker.js', {
    //     enabled: !isDevMode(),
    //     registrationStrategy: 'registerWhenStable:30000'
    // })
],
}).catch((err) => console.error(err));
defineCustomElements(window);
